// extracted by mini-css-extract-plugin
export default {"defaultUserLogo":"User_defaultUserLogo__aROQ5"};